module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"pageTitle":"Смена тарифного плана","warning":"Вы собираетесь сменить тарифный план на "}}')
  delete Component.options._Ctor
}
